import { TypedDocumentNode } from '@graphql-typed-document-node/core'

import {
  FormattedAssignment,
  FormattedAssignmentWithDeletion,
} from 'modules/cost_centers/components/CostCenterAssigments/lib/types'
import { useCostCentersMutations } from 'modules/cost_centers/hooks/useCostCentersMutations'

import { SaveButton } from './SaveButton'

interface Props {
  assignmentsToCreate: FormattedAssignment[]
  assignmentsToUpdate: FormattedAssignmentWithDeletion[]
  disabled: boolean
  resourceId: string
  resourceType: string
  onSave?: () => void
  refetchQueries?: TypedDocumentNode[]
}

export const UpdateButton = ({
  assignmentsToCreate,
  assignmentsToUpdate,
  disabled,
  resourceId,
  resourceType,
  refetchQueries,
  onSave,
}: Props) => {
  const { save } = useCostCentersMutations(refetchQueries)

  const handleOnClick = async () => {
    const successSave = await save({
      assignmentsToCreate: assignmentsToCreate.map((assignment) => {
        return {
          costCenterId: assignment.costCenterId ?? '',
          percentage: assignment.percentage,
          startDate: assignment.startDate,
          // Don't set endDate for default assignments
          endDate: assignment.isDefault
            ? null
            : assignment.endDate === ''
              ? null
              : assignment.endDate,
          resourceId: resourceId,
          resourceType: resourceType,
        }
      }),
      assignmentsToUpdate: assignmentsToUpdate.map((assignment) => {
        return {
          costCenterId: assignment.costCenterId ?? '',
          percentage: assignment.percentage,
          startDate: assignment.startDate,
          // Don't set endDate for default assignments
          endDate: assignment.isDefault
            ? null
            : assignment.endDate === ''
              ? null
              : assignment.endDate,
          id: assignment.id,
          markedForDeletion: !!assignment.markedForDeletion,
        }
      }),
    })

    if (successSave) {
      onSave?.()
    }
  }

  return <SaveButton disabled={disabled} onSave={handleOnClick} />
}
